import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-muted-foreground text-sm" data-testid="auth-loading">Loading…</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (roles && !roles.includes(user.role) && user.role !== "admin") {
    return <Navigate to={roleHome(user.role)} replace />;
  }

  return children;
}

export function roleHome(role) {
  switch (role) {
    case "doctor":
      return "/doctor";
    case "hospital":
      return "/hospital";
    case "admin":
      return "/admin";
    default:
      return "/patient";
  }
}
